import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  useRef,
} from "react";
import TemplateRep1 from "./Templates/TemplateRep1";
import TemplateReg1 from "./Templates/TemplateReg1";
import TemplateReg2 from "./Templates/TemplateReg2";
import { Box, Tab, Tabs } from "@mui/material";
import { TabContext } from "@mui/lab";
import Footer from "src/features/layout/Footer";
import { StyleSettings } from "src/styles/StyleSettings";
import { fnSave } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { Settings } from "@mui/icons-material";
import { getTablebySql } from "@shared/utils/CommonUtils";
import { showPopupModal } from "@widgets/CommonModal";
import DesignerMenuEdit from "./DesignerMenuEdit";
import TemplateReg3 from "./Templates/TemplateReg3";
import TemplateReg4 from "./Templates/TemplateReg4";
import TemplateReg5 from "./Templates/TemplateReg5";

interface Props {
  loadData?: any;
  menuOptions?: any;
  noIssue?: string;
  cdMenu?: string;
  cdTemplate?: string;
}

interface VisibleState {
  [key: string]: boolean;
}

interface TemplateInfo {
  label: string;
  key: string;
  type: React.ComponentType<{ loadData: any; ref: any }>;
}

type ColumnInfo = {
  column_name: string;
  data_type: string;
  character_maximum_length: number | null;
  numeric_precision: number | null;
  numeric_scale: number | null;
  is_nullable: string;
  is_primary_key: "YES" | "NO";
  column_default: string | null;
};

const MainDrawing = forwardRef(
  ({ loadData, menuOptions, noIssue, cdMenu, cdTemplate }: Props, ref) => {
    const [visible, setVisible] = useState<VisibleState>({});
    const tabHeight = "50px";
    const width = 250;
    const [data, setData] = useState<any>();
    const [slipData, setSlipData] = useState<any>();
    const componentRef = useRef<any>(null);
    const { userInfo } = global();

    const templates: TemplateInfo[] = [
      { label: "현황", key: "TemplateRep1", type: TemplateRep1 },
      { label: "1단그리드", key: "TemplateReg1", type: TemplateReg1 },
      { label: "2단그리드(상하)", key: "TemplateReg2", type: TemplateReg2 },
      { label: "2단그리드(좌우)", key: "TemplateReg3", type: TemplateReg3 },
      {
        label: "(좌)그리드, (우)프리폼",
        key: "TemplateReg4",
        type: TemplateReg4,
      },
      {
        label: "(상)프리폼, (하)그리드",
        key: "TemplateReg5",
        type: TemplateReg5,
      },
    ];

    useEffect(() => {
      if (menuOptions != null && loadData != null) {
        setData(loadData);
        if (menuOptions.fg_menu === "REP") {
          setVisible({ TemplateRep1: true });
        } else if (
          Object.keys(loadData?.grid || {}).length === 1 &&
          !loadData?.form
        ) {
          setVisible({ TemplateReg1: true });
        } else if (
          Object.keys(loadData?.grid || {}).length === 2 &&
          !loadData?.form
        ) {
          setVisible({ TemplateReg2: true });
        } else if (
          Object.keys(loadData?.grid || {}).length === 1 &&
          loadData?.form
        ) {
          setVisible({ TemplateReg4: true });
        }
        setSlipData(loadData?.slipData);
      }
      if (cdTemplate != "" && loadData != null) {
        setData(loadData);
        setVisible({ [cdTemplate || ""]: true });
        setSlipData(loadData?.slipData);
      }
    }, [loadData, menuOptions, cdTemplate]);

    useImperativeHandle(ref, () => ({
      downLoadFront,
      downLoadBack,
      save,
    }));

    const save = async () => {
      if (!componentRef || !componentRef.current) return;
      const getData = await componentRef.current.getSaveData();
      const visibleKey = Object.keys(visible)[0];

      const mergedData = {
        ...getData,
        formControlData: await getData.formControlData,
        formData: await getData.formData,
        grid: await getData.grid,
        slipData: slipData ?? {},
      };

      let SaveData;
      if (cdTemplate == "")
        SaveData = {
          sfa_issue_design: {
            insert: [
              {
                cd_firm: userInfo.cd_firm,
                no_issue: noIssue,
                cd_menu: cdMenu,
                cd_template: visibleKey,
                js_setting: mergedData,
              },
            ],
          },
        };
      else
        SaveData = {
          sfa_issue_design: {
            update: [
              {
                cd_firm: userInfo.cd_firm,
                no_issue: noIssue,
                cd_menu: cdMenu,
                cd_template: visibleKey,
                js_setting: mergedData,
              },
            ],
          },
        };
      console.log(SaveData);
      await fnSave("DESIGNER_SAVE_01", SaveData);
    };

    const downLoadFront = async () => {
      const visibleKey = Object.keys(visible)[0];
      const getData = await componentRef.current.getSaveData();

      fetch(`/templates/front/${visibleKey}.txt`)
        .then((res) => res.text())
        .then((data) => {
          let txt = data;
          if (cdMenu) {
            txt = txt.replace(`${visibleKey}_01`, `${cdMenu.toLowerCase()}_01`);
            txt = txt.replace(`${visibleKey}_SAVE_01`, `${cdMenu}_SAVE_01`);
            txt = txt.replaceAll(`${visibleKey}`, `${cdMenu}`);
          }
          if (getData.gridSettings) {
            Object.keys(getData.gridSettings).forEach((key) => {
              txt = txt.replace(
                `@${key}Title`,
                `"${getData.gridSettings[key].title}"`
              );
              txt = txt.replace(
                `@${key}SaveTable`,
                `${getData.gridSettings[key].table}`
              );
              txt = txt.replace(
                `@${key}InitData`,
                JSON.stringify(getData.gridSettings[key].defaultValue).replace(
                  /"/g,
                  ""
                )
              );
              txt = convertButton(txt, getData.gridSettings[key].button, key);
            });
            txt = convertSlipAndFilter(txt, getData.gridSettings);
          }
          const blob = new Blob([txt], { type: "text/plain;charset=utf-8" });
          const url = URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = `${cdMenu || visibleKey}.tsx`;
          a.click();

          URL.revokeObjectURL(url);
        });
    };

    const getColumnsInfo = async (tablename: string) => {
      try {
        const rtn: any[] = await getTablebySql({
          sql: `SELECT
                col.column_name,
                col.data_type,
                col.character_maximum_length,
                col.numeric_precision,
                col.numeric_scale,
                col.is_nullable,
                col.column_default,
                CASE WHEN pk.column_name IS NOT NULL THEN 'YES' ELSE 'NO' END AS is_primary_key
            FROM information_schema.columns col
            LEFT JOIN (
                SELECT 
                    kcu.column_name
                FROM 
                    information_schema.table_constraints tc
                JOIN information_schema.key_column_usage kcu 
                    ON tc.constraint_name = kcu.constraint_name
                    AND tc.table_name = kcu.table_name
                WHERE tc.constraint_type = 'PRIMARY KEY'
                  AND tc.table_name = '${tablename}'
                  AND tc.table_schema = 'snotes'
            ) pk
                ON col.column_name = pk.column_name
            WHERE col.table_name = '${tablename}'
              AND col.table_schema = 'snotes'
            ORDER BY col.ordinal_position;`,
        });
        return rtn;
      } catch (error) {}
    };

    const downLoadBack = async () => {
      const getData = await componentRef.current.getSaveData();
      if (getData.gridSettings) {
        for (const key of Object.keys(getData.gridSettings)) {
          const columnsinfo = await getColumnsInfo(
            getData.gridSettings[key].table
          );

          const files = [
            "Table",
            "TableDto",
            "TableInterface",
            "TableMapper",
            "TablePk",
            "TableRepository",
            "MenuController",
            "MenuService",
            "MenuServiceImpl",
          ];

          for (const file of files) {
            const res = await fetch(`/templates/back/${file}.txt`);
            let txt = await res.text();
            let filename = "";
            txt = txt.replaceAll(`@tablename`, getData.gridSettings[key].table);
            txt = txt.replaceAll(
              `@cdmodule`,
              getData.gridSettings[key].table.substring(0, 3)
            );
            txt = txt.replaceAll(`@cdmenu`, cdMenu || "");
            txt = txt.replaceAll(`@lower_cdmenu`, cdMenu?.toLowerCase() || "");

            if (file === "TableDto" && columnsinfo) {
              txt = txt.replaceAll(
                `@columns`,
                generateJavaDtoFields(columnsinfo)
              );
            }

            // 파일이름 설정 부분
            if (file === "Table" && columnsinfo) {
              txt = txt.replaceAll(`@columns`, generateJavaFields(columnsinfo));
              filename = file
                .replace("Table", getData.gridSettings[key].table)
                .toLowerCase();
            } else if (
              ["MenuController", "MenuService", "MenuServiceImpl"].includes(
                file
              )
            ) {
              // 메뉴 관련 파일
              const suffix =
                file === "MenuController"
                  ? "_controller"
                  : file === "MenuService"
                    ? "_service"
                    : "_serviceImpl";

              filename = (cdMenu || "").toLowerCase() + suffix;
            } else {
              filename = file
                .replace("Table", getData.gridSettings[key].table + "_")
                .toLowerCase();
            }

            if (file === "MenuServiceImpl") {
              const tableList = Object.keys(getData.gridSettings).map(
                (key) => getData.gridSettings[key].table
              );
              const serviceImplData = getServiceImplData(tableList);

              txt = txt.replaceAll(`@import`, serviceImplData.importText);
              txt = txt.replaceAll(`@final`, serviceImplData.finalText);
              txt = txt.replaceAll(`@list`, serviceImplData.listText);
            }

            const blob = new Blob([txt], { type: "text/plain;charset=utf-8" });
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = `${filename}.java`;
            a.click();

            URL.revokeObjectURL(url);
          }
        }
      }
    };

    const mapPostgresTypeToJava = (col: ColumnInfo) => {
      switch (col.data_type) {
        case "character varying":
        case "varchar":
        case "text":
          return "String";
        case "integer":
        case "int":
          return "Integer";
        case "bigint":
          return "Long";
        case "numeric":
        case "decimal":
          return "BigDecimal";
        case "date":
        case "timestamp without time zone":
        case "timestamp with time zone":
          return "Date";
        case "bytea":
          return "byte[]";
        default:
          return "String";
      }
    };

    const generateJavaFields = (columns: ColumnInfo[]) => {
      return columns
        .map((col) => {
          const javaType = mapPostgresTypeToJava(col);

          let annotations = "";

          if (col.is_primary_key === "YES") {
            annotations += "    @Id\n";
          }

          if (javaType === "byte[]") {
            annotations += "    @JdbcTypeCode(SqlTypes.VARBINARY)\n";
            annotations += `    @Column(name = "${col.column_name}", columnDefinition = "bytea")\n`;
          } else if (
            javaType === "BigDecimal" &&
            col.numeric_precision != null &&
            col.numeric_scale != null
          ) {
            annotations += `    @Column(name = "${col.column_name}", nullable = ${
              col.is_nullable === "YES" ? "true" : "false"
            }, precision = ${col.numeric_precision}, scale = ${col.numeric_scale})\n`;
          } else if (javaType === "Date") {
            annotations += `    @Column(name = "${col.column_name}")\n`;
          } else {
            annotations += `    @Column(name = "${col.column_name}", ${
              col.is_nullable === "YES" ? "nullable = true" : "nullable = false"
            }${col.character_maximum_length ? `, length = ${col.character_maximum_length}` : ""})\n`;
          }

          const defaultValue = col.column_default
            ? ` = ${col.column_default.replace(/::[\w\s]+/, "")}`
            : col.is_nullable === "NO" && javaType === "BigDecimal"
              ? " = BigDecimal.ZERO"
              : col.is_nullable === "NO" &&
                  javaType === "String" &&
                  col.column_name.startsWith("yn_")
                ? ' = "Y"'
                : "";

          return `${annotations}    private ${javaType} ${col.column_name}${defaultValue};`;
        })
        .join("\n\n");
    };

    const mapColumnToJavaType = (col: any) => {
      const type = col.data_type.toLowerCase();
      const isPk = col.is_primary_key === "YES";

      if (isPk) {
        // PK는 그냥 일반 타입
        if (type.includes("char") || type.includes("text")) return "String";
        if (type.includes("int")) return "Long";
        return "String";
      }

      if (type.includes("char") || type.includes("text"))
        return "JsonNullable<String>";
      if (type.includes("int4")) return "JsonNullable<Integer>";
      if (type.includes("int2")) return "JsonNullable<Short>";
      if (type.includes("int8") || type.includes("bigint"))
        return "JsonNullable<Long>";
      if (type.includes("numeric") || type.includes("decimal"))
        return "JsonNullable<BigDecimal>";
      if (type.includes("double") || type.includes("float8"))
        return "JsonNullable<Double>";
      if (type.includes("real") || type.includes("float4"))
        return "JsonNullable<Float>";
      if (type.includes("bool")) return "JsonNullable<Boolean>";
      if (type.includes("date") || type.includes("time"))
        return "JsonNullable<Date>";
      if (type.includes("bytea")) return "JsonNullable<byte[]>";
      return "JsonNullable<String>";
    };

    const generateJavaDtoFields = (cols: any[]) => {
      return cols
        .map((col) => {
          const javaType = mapColumnToJavaType(col);
          return `private ${javaType} ${col.column_name};`;
        })
        .join("\n");
    };

    const convertButton = (txt: string, value: string, key: string) => {
      let rtn = txt;
      if (!value) {
        rtn = rtn.replace(`@on${key}BtnsClick`, "");
        rtn = rtn.replace(`@${key}Header`, "");
        return rtn;
      }
      const buttonLabels = value
        .split(",")
        .map((label) => label.trim())
        .filter((label) => label);
      if (value == "") {
        rtn = rtn.replace(`@on${key}BtnsClick`, "");
        rtn = rtn.replace(`@${key}Header`, "");
      } else {
        rtn = rtn.replace(
          `@on${key}BtnsClick`,
          `const on${key.replace("g", "G")}BtnsClick = (id: string) => {
            switch (id) {
              @${key}Case
            }
          };`
        );

        let header: string = "header={";
        let caseId: string = "";
        buttonLabels.map((label) => {
          header =
            header +
            `<SnButton
              key={"${label}"}
              text={"${label}"}
              onClick={() => on${key.replace("g", "G")}BtnsClick("${label}")}
            />`;
          caseId =
            caseId +
            `case "${label}":
              break;`;
        });
        header = header + "}";
        rtn = rtn.replace(`@${key}Header`, header);

        rtn = rtn.replace(`@${key}Case`, caseId);
      }

      return rtn;
    };

    const convertSlipAndFilter = (txt: string, gridSettings: any) => {
      if (!slipData) return txt.replace(`@Slip`, "");

      let gridApis: string = "[";
      let gridInserts: string = "[";
      let saveFIlters: string = "";
      Object.keys(gridSettings).forEach((key) => {
        gridApis = gridApis + `${key}ApiRef,`;
        gridInserts = gridInserts + `${key}Inserts,`;
        if (
          gridSettings[key].filterColumns != null &&
          gridSettings[key].filterColumns != undefined &&
          gridSettings[key].filterColumns.length > 0
        ) {
          let saveColumns: string = "";
          let focusedColumns: string = "";
          let cellValueChangedColumns: string = "";
          let ifColumns: string = "";
          gridSettings[key].filterColumns.forEach((col: string) => {
            if (col === slipData?.column)
              saveColumns = saveColumns + `${col}: noSlip,`;
            else {
              saveColumns =
                saveColumns + `${col}: ${getPrevGrid(key)}FocusedRow.${col},`;
            }
            focusedColumns =
              focusedColumns + `${col}: ${getPrevGrid(key)}FocusedRow.${col},`;
            cellValueChangedColumns =
              cellValueChangedColumns + `${col}: data.rowData.${col},`;
            ifColumns = ifColumns + `"${col}",`;
          });
          saveFIlters =
            saveFIlters +
            `${key}ApiRef.current.applyFilters({ ${saveColumns} });`;
          if (!focusedColumns || focusedColumns == "") {
            txt = txt.replace(`@${key}FocusedRowChangedFilter`, "");
          } else {
            txt = txt.replace(
              `@${key}FocusedRowChangedFilter`,
              `${key}ApiRef.current.applyFilters({ ${focusedColumns} });`
            );
          }
          if (!cellValueChangedColumns || cellValueChangedColumns === "") {
            txt = txt.replace(`@${key}EditValueChangedFilter`, "");
          } else {
            const replaceTxt = `if ([${ifColumns}].includes(data.colId)) {
              ${key}ApiRef.current.applyFilters({ ${cellValueChangedColumns} });
            }`;
            txt = txt.replace(`@grid2EditValueChangedFilter`, replaceTxt);
          }
        }
      });

      gridApis = gridApis + "]";
      gridInserts = gridInserts + "]";
      const rtn = `const slipparams = {
              cd_module: "${slipData?.module.cd_module}",
              no_line: ${slipData?.line.no_line},
              cd_prefix: "${slipData?.prefix}",
              dt: grid1Inserts[0]?.${slipData?.dt},
              girdrefs: ${gridApis},
              inserts: ${gridInserts},
              cd_column: "${slipData?.column}",
            };
            const noSlip = await applySlip(slipparams);
            ${saveFIlters}`;
      return txt.replace(`@Slip`, rtn);
    };

    function getPrevGrid(key: string): string {
      const match = key.match(/grid(\d+)/); // grid 뒤 숫자 추출
      if (!match) return key; // 숫자 없는 경우 그대로 반환
      const num = parseInt(match[1], 10);
      return `grid${num - 1}`;
    }

    /**
     * serviceImpl 파일에서 치환 시 사용할 텍스트 추출 메서드
     * 정렬을 다 맞춰 놨으니 space & tap 사용 시 확인해주세요 - 현지
     * @param tableList 메뉴에서 사용할 테이블 리스트
     */
    function getServiceImplData(tableList: string[]) {
      // 1. import 구문
      const imports = tableList
        .map(
          (table) =>
            `import com.g2sysnet.snotes.cud.data.${table.substring(0, 3)}.${table}.${table};
import com.g2sysnet.snotes.cud.data.${table.substring(0, 3)}.${table}.${table}_dto;
import com.g2sysnet.snotes.cud.data.${table.substring(0, 3)}.${table}.${table}_repository;`
        )
        .join("\n");

      // 2. 상단 변수 선언 구문
      const finals = tableList
        .map(
          (table) => `private final ${table}_repository ${table}_repository;`
        )
        .join("\n\n\t");

      // 3. 선언부 (순서대로)
      const declarations = tableList
        .map(
          (
            table
          ) => `Map<String, Object> ${table}_map = (Map<String, Object>) map.get("${table}");
        List<${table}> ${table}_insertList = objectMapper.extractList(${table}_map, "insert", new TypeReference<>() {});
        List<${table}_dto> ${table}_updateList = objectMapper.extractList(${table}_map, "update", new TypeReference<>() {});
        List<${table}> ${table}_deleteList = objectMapper.extractList(${table}_map, "delete", new TypeReference<>() {});`
        )
        .join("\n\n\t\t");

      // 4. delete (역순)
      const deletes = [...tableList]
        .reverse()
        .map(
          (
            table
          ) => `        if (${table}_deleteList != null && !${table}_deleteList.isEmpty()) {
            ${table}_repository.${table}_d(${table}_deleteList);
        }`
        )
        .join("\n");

      // 5. insert (순서대로)
      const inserts = tableList
        .map(
          (
            table
          ) => `        if (${table}_insertList != null && !${table}_insertList.isEmpty()) {
            ${table}_repository.${table}_i(${table}_insertList);
        }`
        )
        .join("\n");

      // 6. update (순서대로)
      const updates = tableList
        .map(
          (
            table
          ) => `        if (${table}_updateList != null && !${table}_updateList.isEmpty()) {
            ${table}_repository.${table}_u(${table}_updateList);
        }`
        )
        .join("\n");

      return {
        importText: imports,
        finalText: finals,
        listText: [declarations, deletes, inserts, updates].join("\n\n"),
      };
    }

    return (
      <Box sx={{ display: "flex", height: "calc(100vh - 60px)", border: 0 }}>
        <div className="flex justify-between w-full h-full">
          <div className="w-[280px] h-full bg-blue-500 text-white shadow-lg z-50">
            <ul className="p-2 space-y-2">
              {templates.map((tpl) => (
                <div
                  key={tpl.key}
                  className="px-3 py-2 bg-blue-600 rounded hover:bg-blue-400 transition cursor-move"
                  onClick={() => {
                    setData(null);
                    setVisible({ [tpl.key]: true });
                  }}
                >
                  {tpl.label}
                </div>
              ))}
            </ul>
          </div>
          <div className="flex flex-col h-full w-full">
            <Box
              sx={{
                flex: 1,
                backgroundColor: "#f5f5f5",
                height: tabHeight, // Full viewport height
                width: `calc(100vw - ${width}px)`,
              }}
            >
              <TabContext value={0}>
                {/* Tabs */}
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "rgb(186,191,199)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{ zIndex: 1, width: "100%", overflowX: "hidden" }}
                  >
                    {/* 왼쪽: TabList */}
                    <Tabs
                      value={0}
                      variant="scrollable"
                      scrollButtons="auto"
                      sx={{
                        ".MuiTab-root": {
                          color: "white", // 모든 탭의 글자색을 흰색으로 설정
                          backgroundColor: "rgb(151, 151, 151)", // 비활성화된 탭의 배경색
                          "&.Mui-selected": {
                            backgroundColor: "rgb(11, 12, 105)", // 활성화된 탭의 배경색
                            color: "white", // 활성화된 탭의 글자색을 흰색으로 설정
                          },
                        },
                        ".MuiTabs-indicator": {
                          display: "none", // 인디케이터를 숨김
                        },
                        flexShrink: 0, // 탭이 축소되지 않도록 설정
                      }}
                    >
                      <Tab
                        key={"tab1"}
                        value={0}
                        sx={{
                          width: 130,
                          padding: "0px 7px !important", // Tab 자체에 패딩
                          fontSize: `${StyleSettings.font}px`,
                          marginTop: "13px",
                          marginLeft: "10px",
                          minHeight: "35px",
                        }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <Box
                              sx={{
                                display: "inline-block", // 텍스트 영역을 인라인 블록으로 설정
                                overflow: "hidden", // 넘치는 텍스트를 숨기기
                                textOverflow: "ellipsis", // 넘칠 때 ... 표시
                                whiteSpace: "nowrap", // 텍스트 줄 바꿈 방지
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "left",
                              }}
                            >
                              {"신규"}
                            </Box>
                          </Box>
                        }
                      />
                    </Tabs>
                  </div>
                  <Box
                    sx={{
                      width: 100,
                      textAlign: "right",
                      marginRight: "35px",
                    }}
                  >
                    <Settings
                      fontSize="large"
                      className="w-16 h-16 text-blue-500 hover:text-blue-700 transition-colors cursor-pointer shadow-lg rounded-full border-2 border-blue-300 bg-white"
                      onClick={async () => {
                        const component = (
                          <DesignerMenuEdit slipData={slipData} />
                        );
                        const result = await showPopupModal({
                          title: `메뉴설정`,
                          children: component,
                          width: "600px",
                          height: "500px",
                        });
                        if (!result || result === "close") return;
                        setSlipData(result[0]);
                      }}
                    />
                  </Box>
                </Box>

                <div
                  className="tabs"
                  key={0}
                  style={{
                    display: "block",
                    height: "calc(100% - 50px)",
                    width: "100%",
                    flex: 1,
                  }}
                >
                  <Box
                    sx={{
                      overflowY: "auto",
                      height: "100%",
                      width: "100%",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                      paddingRight: "20px",
                      paddingLeft: "16px",
                    }}
                  >
                    <div
                      className="h-full flex flex-col"
                      style={{
                        position: "relative",
                        pointerEvents: "auto",
                      }}
                    >
                      {templates.map((tpl) => {
                        if (!visible[tpl.key]) return null;
                        const Component = tpl.type;
                        return (
                          <Component
                            key={tpl.key}
                            loadData={data}
                            ref={componentRef}
                          />
                        );
                      })}
                    </div>
                  </Box>
                </div>
              </TabContext>
            </Box>

            {/* Footer */}
            <Footer />
          </div>
        </div>
      </Box>
    );
  }
);

export default MainDrawing;
